import Vue from 'vue';
import i18n from '../i18n'
import store from '../store'

const MultiGuard = function(guards){
    return async (to, from, next) => {
        // a flag to discard remaining guards
        let changed = false;
        // handle next for multiple guards
        const mNext = function (value)
        {
            // prevent calling next after it is already resolved with a value
            if(changed) return;

            // if we have 'value' reslove next with the value and set changed flag 
            if(typeof value != 'undefined')
            {
                changed = true;
                next(value);
            }
        };
        // call guards
        for (let i = 0; i < guards.length; i++)
        {
            if(changed) break;
            await guards[i](to, from, mNext);
        }
        // move on if none of guards resolved next with a value
        if(!changed) next();
    }
}

const AssertionResolver =  async function (to, from, next) {
    // Handle language assertion
    let lang = to.query.lang || Vue.localStorage.get('lang')  || i18n.locale
    await store.dispatch('common/CHANGE_LANGUAGE', lang);
    next();
};

const CSSResolver = async function(to, from, next) {  
    let lang = Vue.localStorage.get('lang')
    let ss = document.styleSheets
    for (let s of ss) {
      if (lang === 'en' && (s.href === (window.location.origin + '/static/css/custom-ar.css?v=6122023'))) {
        s.disabled = true
      }
      if (lang === 'ar' && (s.href === (window.location.origin + '/static/css/custom-en.css?v=6122023'))) {
        s.disabled = true
      }
      if (lang === 'en' && (s.href === (window.location.origin + '/static/css/custom-en.css?v=6122023'))) {
        s.disabled = false
      }
      if (lang === 'ar' && (s.href === (window.location.origin + '/static/css/custom-ar.css?v=6122023'))) {
        s.disabled = false
      }
    }
    return next()
};


export { MultiGuard, AssertionResolver, CSSResolver }



// WEBPACK FOOTER //
// ./src/util/NavMiddleware.js